import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSetAtom } from 'jotai';
import lzSAuthLoadedAtom from '@lz-atoms/Auth/loaded';
import lzSAuthTokenAtom from '@lz-atoms/Auth/token';
import lzSAuthUserAtom from '@lz-atoms/Auth/user';

const LzXPageLogout = () => {
  const setSAuthUserState = useSetAtom(lzSAuthUserAtom);
  const setSAuthTokenState = useSetAtom(lzSAuthTokenAtom);
  const setSAuthLoadedState = useSetAtom(lzSAuthLoadedAtom);

  const navigate = useNavigate();

  useEffect(() => {
    setSAuthUserState(null);
    setSAuthTokenState('');
    setSAuthLoadedState(false);

    navigate('/login');
  });

  return <React.Fragment></React.Fragment>;
};

export default LzXPageLogout;
